import React, { useEffect, useState } from 'react'
import { Dropdown, InputGroup, DropdownButton, Form, Button }  from 'react-bootstrap';
import InputMask from 'react-input-mask';
import MultiInput from './MultiInput';

const MASK = "aa-9999-9999-9999-a";

export const TYPE = {

  ALL             : "keywords",
  NUMBER          : "number",
  SENTENCE_NUMBER : "sent_id",
  RECORD_DATE     : "date",
  MULTIKEYWORD    : "multikeyword"

};

const SEARCH_TYPE = [

  { id  : TYPE.ALL,             description :  "Termino Sentencia",  placeholder : "Ingrese un termino de busqueda."},
  { id  : TYPE.NUMBER,          description :  "N° Sentencia",       placeholder : "Ingrese el número de la sentencia"},
  { id  : TYPE.SENTENCE_NUMBER, description :  "Id Sentencia",       placeholder :  "Ingrese el Id de la sentencia." },
  { id  : TYPE.RECORD_DATE,     description :  "Fecha Sentencia",    placeholder : "Ingrese la fecha de la sentencia." },
  { id  : TYPE.MULTIKEYWORD,    description :  "Multi Termino",      placeholder : "Ingrese varios terminos de busqueda."}

]

function SearchInput({
  onChange = (input) =>{},
  onSearch = (input) =>{},
}) {

  // const inputmask = React.ref(null);

  const [selected,set_selected] = useState(SEARCH_TYPE[0]);

  const [input,set_input] = useState({key:"",value:"",placeholder:""});

  const [valid,set_valid] = useState(false);

  const handled_search_type = (type) => set_selected(type);

  const handled_search = () => {  onSearch(input); }
  
  const handled_change = (e) =>{

    set_input(prev_input =>{

      let current_value = e.target.value;

      if(prev_input.key === TYPE.SENTENCE_NUMBER){
        current_value = current_value.toUpperCase();
      }

      return {
        ...prev_input,
        value:current_value
      }
    });

   
  }

  const selectedField = (type)=>{

    let field = null;

    switch(type){
      case TYPE.ALL:{
        field = <Form.Control 
                  key         = { 'input_search'}
                  type        = { 'search' }  
                  onChange    = { handled_change  } 
                  placeholder = { selected.placeholder }
                  value       = { input.value } 
                  onKeyDown   = { (e) => { if(e.code === "Enter") handled_search()} } 
              />;
        break;
      }
      case TYPE.RECORD_DATE:{
        field = <Form.Control 
                  key         = { 'input_date' }
                  type        = { "date" }  
                  onChange    = { handled_change  } 
                  placeholder = { selected.placeholder }
                  value       = { input.value } 
                  onKeyDown   = { (e) => { if(e.code === "Enter") handled_search()} } 
                />;
        break;
      }
      case TYPE.NUMBER:{
        field = <Form.Control 
                  key         = { 'input_number' }
                  type        = { "number" }  
                  onChange    = { handled_change  } 
                  placeholder = { selected.placeholder }
                  value       = { input.value } 
                  onKeyDown   = { (e) => { if(e.code === "Enter") handled_search()} } 
              />
        break;
      }
      case TYPE.SENTENCE_NUMBER:{
        field = <InputMask
                    className       = { 'form-control' }
                    type            = { 'text' }  
                    onChange        = { handled_change  } 
                    value           = { input.value } 
                    onKeyDown       = { (e) => { if(e.code === "Enter") handled_search()  } } 
                    mask            = { MASK }
                    formatChars     = { { 'a': '[aA-zZ]', '9': '[0-9]' } }
                    maskChar        = { null } 
                    alwaysShowMask  = { true }
                    placeholder     = { selected.placeholder }
                />
        break;
      }
      case TYPE.MULTIKEYWORD:{
        field = <MultiInput
                    name        = {'multiInput'}
                    Value           = { input.value } 
                    placeholder = { selected.placeholder }
                    OnChange    = { handled_change  }
                />
        break;
      }
      default :{
        field = null
      }
    }

    return field;
  }

  useEffect(()=>{

    if(input.key !== ""){
      
      switch(input.key){
        case TYPE.ALL:{
          set_valid(()=>input.value !== "".trim());
          break;
        }
        case TYPE.NUMBER:{
          set_valid(()=>input.value !== "".trim());
          break;
        }
        case TYPE.SENTENCE_NUMBER:{
          const maskRegex = /^[A-Za-z]{2}-\d{4}-\d{4}-\d{4}-[A-Za-z]{1}$/;
          set_valid(()=> maskRegex.test(input.value));
          break;
        }
        case TYPE.RECORD_DATE:{
          set_valid(()=> new Date(input.value) <= new Date());
          break;
        }
        case TYPE.MULTIKEYWORD:{
          set_valid(()=> input.value.length > 0);

            handled_search()
          
          break;
        }
        default: console.log("not found type")
      }

    }
    
    // eslint-disable-next-line
  },[input])

  useEffect(()=>{

    set_input(prev_input =>{
      return {
        ...prev_input,
        placeholder : selected.placeholder,
        key         : selected.id,
        value       : ""
      }
    });

    onChange(selected.id);
    // eslint-disable-next-line
  },[selected]);

  return (
    <>
    
      
        <InputGroup>
          <DropdownButton variant="outline-secondary" title={selected.description} id="input-group-dropdown-1" >

          {
            SEARCH_TYPE.map((type,index) => {
              return (<div key={`div${type.id}`}>
                <Dropdown.Divider hidden={index === 0} />
                <Dropdown.Item href="#" onClick={()=>handled_search_type(type)}>{type.description}</Dropdown.Item>
              </div>);
              
            })
          }
          </DropdownButton>
          {selectedField(selected.id)}
          <Button variant="outline-primary" id="button-addon2" onClick={handled_search} disabled = {!valid}>
            Buscar
          </Button>
        </InputGroup>
    </>
  )  
}

/* n°sentencia, Contenidio, Contenido_P,fecha_registro,resumen,materia,relito,*/

export default SearchInput